import React from 'react';
import { withContent } from '../../../hoc/withContext';
import './Loader.scss';
import { IContent } from '../../../types';

interface ILoaderProps {
  context?: IContent;
  minHeight?: string
}

const Loader = ({ context, minHeight }: ILoaderProps) => {
  return (
    <div className="initialized" style={{ minHeight }}>
      <span className="dot" />
      <span className="dot" />
      <span className="dot" />
    </div>
  );
};

export default withContent(Loader);
